import React, { useState } from 'react';
import {ReactComponent as ActiveIcon} from '../../components/svgs/activeIcon.svg'
import {ReactComponent as OfficeWorkerIcon} from '../../components/svgs/officeWorkerIcon.svg';
import {ReactComponent as SearchIcon} from '../../components/svgs/searchicon.svg';
import {ReactComponent as FilterIcon} from '../../components/svgs/filterIcon.svg';
import {ReactComponent as ExportIcon} from '../../components/svgs/exportIcon.svg';
import {ReactComponent as PersonalAccountIcon} from '../../components/svgs/personalAccountIcon.svg';


import { Link } from 'react-router-dom';


const ManagerCustomerTab = () => {

    const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      title: 'Personal Accounts',
      icon: <PersonalAccountIcon/>,
      tableData: [
        { customerName: 'Phoebe Buffay', noOfOrders: '23', phoneNumber: '+123456789', emailAddress: 'phoebe.b@mail.com', viewButton: '/manager/customers/customers-details' },
        { customerName: 'Ross Geller', noOfOrders: '11', phoneNumber: '+123456789', emailAddress: 'phoebe.b@mail.com', viewButton: '#' },
        { customerName: 'Joey Tribbiani', noOfOrders: '7', phoneNumber: '+123456789', emailAddress: 'phoebe.b@mail.com', viewButton: '#' },
        { customerName: 'Monica Geller', noOfOrders: '23', phoneNumber: '+123456789', emailAddress: 'phoebe.b@mail.com', viewButton: '#' },
        { customerName: 'Chandler Bing', noOfOrders: '11', phoneNumber: '+123456789', emailAddress: 'phoebe.b@mail.com', viewButton: '#' },
        
      ]
    },
    {
      title: 'Commercial Accounts',
      icon: <OfficeWorkerIcon/>,
      tableData: [
        { customerName: 'Phoebe Buffay', noOfOrders: '23', phoneNumber: '+123456789', emailAddress: 'phoebe.b@mail.com', viewButton: '#' },
        { customerName: 'Ross Geller', noOfOrders: '11', phoneNumber: '+123456789', emailAddress: 'phoebe.b@mail.com', viewButton: '#' },
        { customerName: 'Joey Tribbiani', noOfOrders: '7', phoneNumber: '+123456789', emailAddress: 'phoebe.b@mail.com', viewButton: '#' },
        { customerName: 'Monica Geller', noOfOrders: '23', phoneNumber: '+123456789', emailAddress: 'phoebe.b@mail.com', viewButton: '#' },
        { customerName: 'Chandler Bing', noOfOrders: '11', phoneNumber: '+123456789', emailAddress: 'phoebe.b@mail.com', viewButton: '#' },
        
      ]
    },
  
  ];


  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <>
    <div className="tab-container">

        <div className="tab-titles">
        {tabs.map((tab, index) => (
            <div
            key={index}
            className={`tab-title ${activeTab === index ? 'active' : ''}`}
            onClick={() => handleTabClick(index)}
            >
            <div className={`tab-icon ${activeTab === index ? 'active' : ''}`}>
                {React.cloneElement(tab.icon, {
                className: activeTab === index ? 'active-icon' : ''
                })}
            </div>
            <div className={`tab-label ${activeTab === index ? 'active' : ''}`}>{tab.title}</div>
            </div>
        ))}
        </div>

        <section className='flex search-filter-section mt-4 mb-4 ml-4'>
            <section>
                <form action="">
                <label htmlFor="" className="flex flex-col order-search-input">
                    <SearchIcon className='order-search-icon search-icon'/>
                    <input type="text" placeholder="Search" className="mt-2"/>
                </label>
                </form>
            </section>
            <section className='flex gap-10 mt-10 ml-20'>
                <div className='flex gap-4'>
                    <FilterIcon/>
                    <p className='filter-section-text'>Filter</p>

                </div>
                <div className='flex gap-4'>
                    <ExportIcon/>
                    <p className='filter-section-text'>Export as csv</p>
                    
                </div>
            </section>
        </section>    
            

      <div className="tab-content">
        {tabs.map((tab, index) => (
          <div key={index} className={`tab-pane ${activeTab === index ? 'active' : ''}`}>
            <table className="custom-table custom-order-table">

              <thead>
                <tr className='table-head'>
                  <th className=''>
                    Customer Name
                    <span className="filter-icon">
                      <ActiveIcon />
                      
                    </span>
                  </th>
                  <th className=''>
                    No of orders
                    <span className="filter-icon">
                    <ActiveIcon className=''/>
                    </span>
                  </th>
                  <th>
                    Phone number
                    <span className="filter-icon">
                    <ActiveIcon />
                    </span>
                  </th>
                  <th>
                    Email address
                    <span className="filter-icon">
                      <ActiveIcon />
                    </span>
                  </th>
                  
                </tr>
              </thead>

              <tbody className='table-body'>
                {tab.tableData.map((data, dataIndex) => (
                  <tr key={dataIndex} className='table-row'>
                    <td className='table-data-1'>
                      {data.customerName}
                      
                    </td>
                   
                    <td className='table-data-1'>
                      {data.noOfOrders}
                      <div className='customer-rep'>{data.commercialCustomerRep}</div>
                    </td>
                   
                    <td className='table-data'>
                      {data.phoneNumber}
                    
                    </td>
                    <td className='table-data'>
                      {data.emailAddress}
                    
                    </td>
                    
                    <td>
                        <Link to={data.viewButton} className='view-btn'>View</Link>
                    </td>
                    
                    
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

export default ManagerCustomerTab